module.exports = __webpack_public_path__ + "img/icon-ssl.4e238afa.svg";